module.exports = __webpack_public_path__ + "img/normal-buy-hen.a44f0832.png";